$(function(){
  //setupAppControlByKeyboard();
  setupKeyboardCommands();
})

function setupKeyboardCommands(){
  if($('.key-commands').length < 1) return

    $(window).keypress(function(e){
        if($('input:focus, textarea:focus, button:focus').length > 0) return
        var keyCode = e.keyCode || e.charCode;  // e.keyCode == 0 in Firefox, so we need to use e.charCode!
        var letter = String.fromCharCode(keyCode)
        if (typeof letter == "number") {
          letter = letter.toString();
        }
        
        letter = letter
            .replace(' ', 'space')
            .replace('ě', 'ecaron')
            .replace('š', 'scaron')
            .replace('č', 'ccaron')
            .replace('ř', 'rcaron')
            .replace('ž', 'zcaron')
            .replace('ý', 'yacute')
            .replace('á', 'aacute')
            .replace('í', 'iacute')
            .replace('é', 'eacute')
            .replace('ú', 'uacute')
            .replace('ů', 'ucircle')
            .replace('ľ', 'lcaron')
            .replace('ť', 'tcaron')
            .replace('ô', 'ovokan')
            .replace('ä', 'adots')
            .replace('ň', 'ncaron')
            .replace('?', 'question')
            .replace('!', 'exclamation')
            .replace('(', 'bracketleft')
            .replace(')', 'bracketright')
            .replace('"', 'quote')
            .replace('@', 'at')
            .replace('-', 'dash')
            .replace('/', 'slash')
            .replace(':', 'colon')
            .replace(';', 'semicolon')
            .replace('.', 'dot')
            .replace(',', 'comma')
            .toLowerCase()

        handleLetter(letter, e)
    })

    // CATCH SPECIAL CHARACTERS USING KEYDOWN
    var keys = {
            insert: 45,
            delete: 46
        },
        key_names = Object.keys(keys),
        keys_flipped = key_names
            .filter(keys.hasOwnProperty.bind(keys))
            .reduce(function(obj, key) {
                obj[keys[key]] = key;
                return obj;
            }, {}),
        key_values = Object.keys(keys_flipped)

    var selector = key_names.reduce(function(selector, key_name) {
        return selector+".kc-"+key_name+", "
    }, "")
    selector = selector.substr(0, selector.length-2)

    if($('.key-commands').find(selector).length >= 1) {
        $(window).keydown(function (e) {
            if ($('input:focus, textarea:focus, button:focus').length > 0) return

            var keyCode = e.which.toString(),
                letter = false,
                keys_index = key_values.indexOf(keyCode)

            if(keys_index !== -1) {
                letter = keys_flipped[key_values[keys_index]]
                handleLetter(letter, e)
            }
        })
    }

    var handleLetter = function(letter, e) {

        if (/^[a-zA-Z-]+$/.test(letter) === false) return
        var btns = $('.kc-' + letter + ':visible').selectVisible()
        if (btns.length > 0) {
            e.preventDefault()
            e.stopPropagation()
            for (var i = 0; i < btns.length; i++) {
                btns[i].click()
                if ($(btns[i]).hasClass('kc-prevent-default')) e.preventDefault()
            }
        }
    }
}

+function($){

  $.fn.selectVisible = function(){
    return this.filter(function(i, o){
      var parentsOk = true
      $(this).parents().each(function(x, y){
        if($(this).css('opacity') <= 0 || ['hidden', 'collapse', 'collapsed'].indexOf($(this).css('visibility')) >= 0)
          parentsOk = false
      })
      return $(this).css('opacity') > 0 && ['hidden', 'collapse', 'collapsed'].indexOf($(this).css('visibility')) < 0 && parentsOk
    })  
  }

}(jQuery)


function setupAppControlByKeyboard() {
  // nevi, jestli je lepsi keydown nebo keypress; kazdopadne, je na tom navesene i ovladani hry (games/common.js), tzn. 2 handlery; zatim to nevadilo, ale muzou se bit, pozor na to!
  //jQuery(document.body).on("keydown", handleKeyboardCommand);
  jQuery(document.body).on("keypress", handleKeyboardCommand);

  //@TODO mozna pouzit tuhle sikovnou knihovnu: https://craig.is/killing/mice
}

function handleKeyboardCommand(event) {
  /*// je-li uzivatel v nejakem formulari, nechceme pouzit ovladani z klavesnice
  if ($('input:focus, textarea:focus, button:focus').length > 0) { return; }
  var letter = String.fromCharCode(event.charCode);

  //@TODO sem pribudou ruzne klavesy, kterymi se web Psani Hrave da ovladat (bez pouziti mysi)
  //  pak bude ovsem potreba to zrefaktorovat (udelat na to specialni objekt), at v tom neni bordel

  // v minidashboardu zabranime standardnimu efektu "page down" (delaji prohlizece pri stisku mezerniku)
  if ($('.dashboard .afterPlay').length > 0 && letter == ' ') {
    event.preventDefault();
  }

  if ($('.afterPlay:visible').length == 0) { return; } // jen na strance, kde mame obrazovku po hre (minidashboard a homepage)
  
  if (letter == ' ') {
    //@TODO elegantneji (chci kliknout jen tehdy, kdyz je .btn-continue videt)
    if ($('.btn-continue:visible').length > 0) {
      $('#floatingCirclesG.down').removeClass('hidden');
      $('.btn-continue')[0].click();
    }
    
    // zabranit propagaci a provedeni u mackani mezerniku po hre chci vzdycky
    event.preventDefault();
    event.stopPropagation();
  }
  if (letter == 'a') {
    $('#floatingCirclesG.up').removeClass('hidden');
    $('.btn-repeat')[0].click();
    event.preventDefault();
    event.stopPropagation();
  }*/
}
